import { formatDateTime, t, textStatusWord, type DateFormat, type TextThreadRow } from '@bms2/shared';
import styles from './PersonTextsPanel.module.css';

/**
 * 🔒 A texts thread as the Person page's Texts tile draws it (decision 5210), shared with the phone system's Texts thread
 * (decision 11860): oldest first, an outbound text at the right with its status word, an inbound one at the left
 * reading Received, each with its time in the viewer's zone and format.
 */
export function TextThreadList({ rows, zone, dateFormat }: { rows: readonly TextThreadRow[]; zone: string; dateFormat: DateFormat }) {
  return (
    <ol className={styles.thread}>
      {rows.map((row) => (
        <li key={row.id} className={row.direction === 'Outbound' ? styles.outbound : styles.inbound} data-text-direction={row.direction}>
          <p className={styles.body}>{row.body}</p>
          <p className={styles.meta}>
            {[formatDateTime(row.at, zone, dateFormat), row.direction === 'Outbound' ? textStatusWord(row.status) : t('textThread.received')].join(' · ')}
          </p>
        </li>
      ))}
    </ol>
  );
}
